/* eslint-disable */
import Tab from '@/Components/InfoTab/tab';
import VariantTable from '../Food Products/VariantPrice/VariantTable';
import DocumentsImagesSection from '../Analytics/Inventory Analytics/PurchaseOrderList/DocumnetSection';

const heightClasses = {
    100: 'h-[calc(100vh-100px)]',
    200: 'h-[calc(100vh-200px)]',
    250: 'h-[calc(100vh-250px)]',
    300: 'h-[calc(100vh-300px)]',
    400: 'h-[calc(100vh-400px)]',
    500: 'h-[calc(100vh-500px)]',
    600: 'h-[calc(100vh-600px)]',
    700: 'h-[calc(100vh-700px)]',
    800: 'h-[calc(100vh-800px)]',
    900: 'h-[calc(100vh-900px)]',
}
function TableWithTabs(props) {
    const { tableWithTabsRef = null, tabInfo = {}, tableInfo = {}, data = [], height = 500, highLightRow = null, virtualization = false, deferRender = false, renderLegend = () => { }, tableWidthFit = false, note = '' } = props;
    const { tabList = [], tabValue = '', handleTabChange = () => { }, activeTabColor = 'bg-yellow-500' } = tabInfo;
    const { tableRows = {}, tableColumns, data: tableData = [], customCol = () => { }, handlePreview = () => { }, list = [], sortInfo = {} } = tableInfo;
    return (
        <div ref={tableWithTabsRef}>
            <div className='flex justify-between items-center gap-4'>
                <div className='flex-shrink-0 whitespace-nowrap overflow-x-auto'>
                    {tabList?.length > 0 && (
                        <Tab
                            tabList={tabList}
                            tabValue={tabValue}
                            handleTabChange={handleTabChange}
                            activeTabColor={activeTabColor}
                        />
                    )}
                </div>
                <div className='flex-shrink-0'>
                    {renderLegend()}
                </div>
            </div>
            {note && note?.length > 0 && (
                <div className='text-[11px] font-medium text-red-600 bg-red-50 px-2.5 py-1 rounded border border-red-100 mt-1 truncate' title={note}>
                    {note}
                </div>
            )}
            {/* height="auto": the table shrinks to its rows but never grows past the screen, so its
                own scroll box keeps the sticky header pinned at the top while scrolling the rows.
                The cap is set on VariantTable's root (the element that scrolls). */}
            <div className={height === 'auto' ? '[&>div]:max-h-[calc(100vh-90px)]' : `overflow-y-auto ${heightClasses[height]}`}>
                {tabValue === 'documents' ? (
                    <DocumentsImagesSection handlePreview={handlePreview} documents={list} />
                ) : (
                    <VariantTable
                        data={tableData}
                        columns={tableColumns}
                        customRowData={tableRows}
                        customCol={customCol}
                        sortValueInfo={sortInfo}
                        highLightRow={highLightRow}
                        deferRender={deferRender}
                        tableWidthFit={tableWidthFit}
                    />
                )}
            </div>
        </div>
    );
}
export default TableWithTabs;
